import React from 'react';
import Template from '../Template/Template';

export const ReInitiated = ({ handleClose, navigateToLinkedBankAccounts }) => {
  return (
    <Template
      header={`This bank is ready to be verified.`}
      nextButton={`Verify Your Bank Now`}
      backButton={`Cancel`}
      onBackClick={handleClose}
      onNextClick={navigateToLinkedBankAccounts}
    >
      <p>
        You should have received an e-mail informing you that two small deposits
        of less than $1.00 were made into your bank account. Now you need to
        verify these deposit amounts.
        <br />
      </p>
      <ul>
        <li>
          Review your bank account transactions and find the two small deposits
          made by T. Rowe Price.
        </li>
        <li>
          Confirm the deposits and their amounts here:{' '}
          <a onClick={navigateToLinkedBankAccounts}>Verify Your Bank Now</a>
        </li>
      </ul>
      <br />
      If you did not initiate this request, please send us a secure e-mail
      message or contact T. Rowe Price Customer Service at{' '}
      <a className="phone">(800) 225-5132</a>.
    </Template>
  );
};
